import React, { type FunctionComponent, type CSSProperties } from 'react'
import { DashText, type DashTextProps } from 'legacy/dash-blocks/dash-text/DashText'
import { Flex } from 'legacy/dash-blocks/flex/Flex'

const baseStyle: CSSProperties = { display: 'flex', alignItems: 'center' }

export const DashTableTextCell: FunctionComponent<DashTextProps> = ({
  size = 'small',
  overrideStyle = {},
  ...rest
}) => (
  <Flex fillWidth fillHeight align="center">
    <DashText
      size={size}
      elementType="div"
      overrideStyle={{ ...baseStyle, ...overrideStyle }}
      {...rest}
    />
  </Flex>
)
